import UserCurrentCheckin from './UserCurrentCheckin.container';

export default UserCurrentCheckin;
